export default __webpack_public_path__ + "education6ce995.jpg";